var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "alert alert-warning" }, [
    _vm._v("This product has been discontinued. "),
    _setup.props.replacement
      ? _c("span", [
          _vm._v("Please view our replacement product "),
          _c("a", { attrs: { href: _setup.url } }, [
            _vm._v(_vm._s(_setup.props.replacement.name)),
          ]),
          _vm._v("."),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }